import { lazy } from "react"

export { default as Header } from "./Header/Header"
export { default as Background } from "./GuaranteedIncome/Background"
export { default as IncomePlan } from "./GuaranteedIncome/IncomePlan"
export { default as Calculator } from "./GuaranteedIncome/Calculator"

const Benefits = lazy(() => import("./GuaranteedIncome/Benefits"))
const Steps = lazy(() => import("./Steps/Steps"))
const WhyUs = lazy(() => import("./WhyUs/WhyUs"))
const Recommended = lazy(() => import("./Recommended/Recommended.js"))
const KeyTerms = lazy(() => import("./KeyTerms/KeyTerms.js"))
const WhatIs = lazy(() => import("./WhatIS/WhatIs"))
const PlanWorks = lazy(() => import("./PlanWorks/PlanWorks.js"))
const VideoModal = lazy(() => import("./PlanWorks/VideoModal.js"))
const MaxReturns = lazy(() => import("./MaxReturns/MaxReturns.js"))
const TalkToExpertModal = lazy(() => import("./Header/TalkToExpertModal.js"))
const Faq = lazy(() => import("./Faq/Faq.js"))
const Disclaimer = lazy(() => import("./Disclaimer/Disclaimer.js"))
const Footer = lazy(() => import("./Footer/Footer"))
const AppFormBOO = lazy(() => import("./AppForm/AppFormBOO"))
const SuitabilityModal = lazy(() => import("./Suitability/SuitabilityModal"))

export { Benefits, Steps, SuitabilityModal, TalkToExpertModal, WhatIs, AppFormBOO, Footer, Disclaimer, Faq, MaxReturns, VideoModal, PlanWorks, KeyTerms, Recommended, WhyUs }